var __TEMP__ = require('./_createMathOperation.js');var createMathOperation = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = createMathOperation(function(augend, addend) {
  return augend + addend;
}, 0);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = add;
